import { useCallback, useEffect, useState } from "react";
import { Edit, useDataProvider, useNotify } from "react-admin";

import { arrayMove } from "react-sortable-hoc";
import { SortableComponent } from "./component/subcat-filters-edit-sortable-list";

// edit page = reorder page

export const FilteringEdit = (props) => {
  const notify = useNotify();

  const dataProvider = useDataProvider();
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [dummy, setDummy] = useState(1);

  const onSortEnd = async ({ oldIndex, newIndex }) => {
    const tempRows = JSON.parse(JSON.stringify(rows));

    const promise = apiReorder(rows[oldIndex], rows[newIndex]);
    const r = arrayMove(rows, oldIndex, newIndex);
    setRows(r);
    const result = await promise;

    // if error , revert the rows
    if (result.error) {
      setRows(tempRows);
    }

    setDummy(dummy + 1);
  };

  const apiReorder = useCallback(async (oldRow, newRow) => {
    const diff = newRow.order - oldRow.order;

    try {
      const promise = dataProvider.updateSubcatFilters("subcat-filters", {
        id: oldRow._id,
        order: oldRow.order + diff,
      });

      const result = await promise;

      return {
        data: result,
      };
    } catch (error) {
      notify(error.message.toString(), "warning");
      return {
        error: error.message.toString(),
      };
    }
  });

  useEffect(() => {
    dataProvider
      .getManySubcatFilters("subcat-filters", props.id)
      .then(({ data }) => {
        setRows(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [dummy]);

  // if (loading) return <Loading />;
  if (loading)
    return (
      <>
        <div>loading</div>
      </>
    );
  if (error)
    return (
      <>
        <div>error</div>
      </>
    );
  if (!rows)
    return (
      <>
        <div>no data</div>
      </>
    );

  return (
    <>
      <Edit {...props}>
        {rows ? (
          <SortableComponent rows={rows} onSortEnd={onSortEnd} />
        ) : (
          <>
            <div>sorry i have no data</div>
          </>
        )}
      </Edit>
    </>
  );
};
